import React from 'react';
import PdfHeaderComponent from './PdfHeaderComponent';
import { getProjectStatistics } from "../../../../apis/impact-report/report";
import useFetchData from "../../../../hooks/useFetchData";
import PdfHorizontalBarChart from "./charts/PdfHorizontalBarChart";
import Loader from "../../../../ui/Loader";
import { paginateHorizontalBarData, calculateChartDomain, generatePageTitle } from './utils/chartPagination';

const SDGsPageComponent = ({ projectId, projectData }) => {
  // Fetch SDGs data
  const { loading, response } = useFetchData(
    getProjectStatistics,
    [projectId, "SDG_WISE_BOUNTY_COUNT", "", ""],
    [projectId, "SDG_WISE_BOUNTY_COUNT", "", ""]
  );

  // Transform SDGs data
  const sdgsData = response?.sdgWiseBountyCount?.map(item => ({
    name: item.SDG,
    value: item.bountyCount
  }))?.sort((a, b) => b?.value - a?.value) || [];

  // Paginate SDGs data
  const paginatedSDGsData = paginateHorizontalBarData(sdgsData, 27);
  const sdgDomainData = calculateChartDomain(sdgsData);

  if (loading) {
    return (
      <div className="pdf-section pdf-page-break" style={{ display: 'flex', flexDirection: 'column', padding: '20px' }}>
        <PdfHeaderComponent projectTitle={projectData?.title} organizationName="Solarpunk Guild" />
        <div className='w-full h-[23.9375rem] flex pt-11 justify-center'>
          <Loader />
        </div>
      </div>
    );
  }

  if (paginatedSDGsData.length === 0) {
    return (
      <div className="pdf-section pdf-page-break" style={{ display: 'flex', flexDirection: 'column', padding: '20px' }}>
        <PdfHeaderComponent projectTitle={projectData?.title} organizationName="Solarpunk Guild" />
        <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
          <h2 className="text-lg font-bold text-gray-900 mb-2">Sustainable Development Goals (SDGs)</h2>
          <p className="text-xs text-gray-600 mb-3">Number of activities per SDG</p>
          <div className="bg-grayBgNormal p-4 rounded-lg border border-gray-200 text-center text-gray-500" style={{ height: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div className="text-xs">No SDGs data available</div>
          </div>
        </div>
      </div>
    );
  }

  // Render each page of SDGs data
  return (
    <>
      {paginatedSDGsData.map((pageData, pageIndex) => {
        const pageNumber = pageIndex + 1;
        const totalPages = paginatedSDGsData.length;
        const pageTitle = generatePageTitle("Sustainable Development Goals (SDGs)", pageNumber, totalPages);
        return (
          <div key={`sdgs-page-${pageIndex}`} className="pdf-section pdf-page-break" style={{ display: 'flex', flexDirection: 'column', padding: '20px', height: '100vh' }}>
            <PdfHeaderComponent projectTitle={projectData?.title} organizationName="Solarpunk Guild" />
            <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
              <h2 className="text-lg font-bold text-gray-900 mb-2">{pageTitle}</h2>
              <p className="text-xs text-gray-600 mb-3">Sustainable Development Goals alignment</p>
              
              <div className="bg-grayBgNormal p-4 rounded-lg " style={{ flex: 1, minHeight: '980px' }}>
                <PdfHorizontalBarChart
                  data={pageData}
                  xAxisLabel="SDG alignment score"
                  yAxisLabel="SDGs"
                  barSize={16}
                  showReferenceLine={true}
                  referenceLineValue={Math.max(...sdgDomainData.ticks) * 0.5}
                  domain={sdgDomainData.domain}
                  ticks={sdgDomainData.ticks}
                  showLegend={false}
                />
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default SDGsPageComponent;
